import { ICustomerInfo } from "@models/dto/Rocketta/LicenseServer/Models/Customers/ICustomerInfo";
import { IResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/IResponseModel";
import { AxiosResponse } from "axios";
import LicenseServerBaseApi from "./baseApi";
import { IEditCustomerRequest } from "@models/dto/Rocketta/LicenseServer/Models/Customers/IEditCustomerRequest";

export class CustomersApi {
  static getCustomers(): Promise<AxiosResponse<IResponseModel<ICustomerInfo[]>>> {
    return LicenseServerBaseApi.get<ICustomerInfo[]>("/customer/customers");
  }
  static editCustomer(data: IEditCustomerRequest): Promise<AxiosResponse<IResponseModel<ICustomerInfo>>> {
    return LicenseServerBaseApi.putWrapped<ICustomerInfo>("/customer/Edit", data);
  }
}
